var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mb-0 p-2 has-shadow has-background-info",
      attrs: { id: "bread-container" },
    },
    [
      _c(
        "nav",
        {
          staticClass: "breadcrumb m-0 is-hidden-touch",
          class: { "is-medium": _vm.size != "is-small" },
          attrs: { "aria-label": "breadcrumbs" },
        },
        [
          _c(
            "ul",
            {},
            _vm._l(_vm.routes, function (ruta, index) {
              return _c(
                "li",
                { key: index },
                [
                  _vm.routes.length - 1 != index
                    ? _c(
                        "router-link",
                        {
                          staticClass: "has-text-white",
                          attrs: {
                            to:
                              _vm.root +
                              _vm.routes.slice(0, index + 1).join("/"),
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-fw",
                            class: _vm.icon(index),
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                ruta.length > 20
                                  ? ruta.substring(0, 20) + "..."
                                  : ruta
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c("a", { staticClass: "has-text-white" }, [
                        _c("i", {
                          staticClass: "fas fa-fw",
                          class: _vm.icon(index),
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              ruta.length > 20
                                ? ruta.substring(0, 20) + "..."
                                : ruta
                            ) +
                            "\n      "
                        ),
                      ]),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown",
        {
          staticClass: "is-hidden-desktop",
          staticStyle: { "margin-top": "-1px" },
          attrs: { "aria-role": "list" },
          scopedSlots: _vm._u([
            {
              key: "trigger",
              fn: function ({ active }) {
                return _c(
                  "a",
                  { staticClass: "has-text-white button-dropdown" },
                  [
                    _c("i", {
                      staticClass: "far fa-fw",
                      class: {
                        "fa-file": _vm.endsFile,
                        "fa-folder-open": !_vm.endsFile,
                      },
                    }),
                    _vm._v(" " + _vm._s(_vm.lastRoute) + " "),
                    _c("i", {
                      staticClass: "fas",
                      class: {
                        "fa-chevron-up": active,
                        "fa-chevron-down": !active,
                      },
                    }),
                  ]
                )
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm._l(_vm.routes, function (ruta, index) {
            return _c(
              "b-dropdown-item",
              {
                key: index,
                attrs: { "aria-role": "listitem", "has-link": "" },
              },
              [
                _vm.routes.length - 1 != index
                  ? _c(
                      "a",
                      {
                        staticClass: "has-text-dark",
                        on: {
                          click: function ($event) {
                            _vm.goToRoute(
                              _vm.root +
                                _vm.routes.slice(0, index + 1).join("/")
                            )
                          },
                        },
                      },
                      [
                        _c("span", {
                          style: { paddingLeft: `${index * 10}px` },
                        }),
                        _c("i", {
                          staticClass: "far fa-fw",
                          class: _vm.icon(index),
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              ruta.length > 20
                                ? ruta.substring(0, 20) + "..."
                                : ruta
                            ) +
                            "\n    "
                        ),
                      ]
                    )
                  : _c(
                      "a",
                      { staticClass: "has-text-dark has-text-weight-bold" },
                      [
                        _c("span", {
                          style: { paddingLeft: `${index * 10}px` },
                        }),
                        _c("i", {
                          staticClass: "far fa-fw",
                          class: _vm.icon(index),
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              ruta.length > 20
                                ? ruta.substring(0, 20) + "..."
                                : ruta
                            ) +
                            "\n      "
                        ),
                      ]
                    ),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }